import React from "react";
import { Helmet } from "react-helmet-async";
import { APP_BRAND_FOLDER, APP_BRAND_NAME } from "../utils/consts";
import GA from "../utils/google-analytics"

const BrandMetadata = () => { 
  return (
    <>
    { GA.init() && <GA.RouteTracker /> }
    <Helmet>
      <title>Meeting Suite - {APP_BRAND_NAME}</title>
      <link rel="icon" href={`/brands/${APP_BRAND_FOLDER}/img/favicon.ico`} />
      <link
        rel="shortcut icon"
        href={`/brands/${APP_BRAND_FOLDER}/img/favicon.ico?v=1`}
      />
      <link
        rel="icon"
        href={`/brands/${APP_BRAND_FOLDER}/img/favicon.ico?v=1" type="image/x-icon`}
      />
      <link
        rel="apple-touch-icon"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.57x57.png`}
      />
      <link
        rel="apple-touch-icon"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.72x72.png" media="screen and (min-device-width: 481px) and (max-device-width: 1024px)`}
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.72x72.png`}
      />
      <link
        rel="apple-touch-icon"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.114x114.png" media="screen and (-webkit-min-device-pixel-ratio: 2)`}
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.114x114.png`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.57x57.png`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.72x72.png" media="screen and (min-device-width: 481px) and (max-device-width: 1024px)`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="72x72"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.72x72.png`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.114x114.png" media="screen and (-webkit-min-device-pixel-ratio: 2)`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="114x114"
        href={`/brands/${APP_BRAND_FOLDER}/img/apple-touch-icon.114x114.png`}
      />
      <meta name="description" content={`${APP_BRAND_NAME} Meeting Suite`} />
      <link
        rel="stylesheet"
        href={`/brands/${APP_BRAND_FOLDER}/css/theme.css`}
      />
    </Helmet>
    </>
  );
};

export default BrandMetadata;
